module.exports = __webpack_public_path__ + "img/course_bg6.064eea7d.png";